import { render, staticRenderFns } from "./guanf.vue?vue&type=template&id=0c021b60&scoped=true"
import script from "./guanf.vue?vue&type=script&lang=js"
export * from "./guanf.vue?vue&type=script&lang=js"
import style0 from "./guanf.vue?vue&type=style&index=0&id=0c021b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c021b60",
  null
  
)

export default component.exports